module.exports = __webpack_public_path__ + "img/icon-rocket.5f78a33f.svg";